import { useEffect } from 'react';

const useClickEventListener = ({ className = '', callback = () => {} }) => {
  const navbarCloseButtonDesktop =
    document.getElementsByClassName(className)?.[0];
  const navbarCloseButtonMobile =
    document.getElementsByClassName(className)?.[1];
  useEffect(() => {
    const listener = (e) => {
      e?.preventDefault();
      callback();
    };
    navbarCloseButtonDesktop?.addEventListener('mousedown', listener);
    navbarCloseButtonMobile?.addEventListener('touchstart', listener);
    return () => {
      navbarCloseButtonDesktop?.removeEventListener('mousedown', listener);
      navbarCloseButtonMobile?.removeEventListener('touchstart', listener);
    };
  }, [navbarCloseButtonDesktop, navbarCloseButtonMobile]);
};

export default useClickEventListener;
